<template>
  <div id="page-product-form">
    <vs-row>
      <vs-col>
        <card-page :card-title="cardTitle">
          <vue-element-loading :active="busy"></vue-element-loading>
          <vue-form-generator
              class="mt-4"
              ref="form"
              :model="model"
              :options="formOptions"
              :schema="schema"
          />
        </card-page>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>

import FormModelMixin from '@/components/mixins/FormModelMixin';
import FormFieldValidationMixin from "@/components/mixins/FormFieldValidationMixin";
import {selectOptions, datepickerOptions} from '@/components/form/FormElementOption';
import moment from 'moment';
import CardPage from '../../../../components/Views/CardPage';

export default {
  name: 'AncestorsForm',
  props: {
    value: {
      type: Object,
      required: true
    },
    cardTitle: {
      type: String,
      required: false,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  components: {
    CardPage
  },
  mixins: [FormModelMixin, FormFieldValidationMixin],
  data() {
    return {
      loadingSections: false,
      selectedReferences: [],
      model: {
        facility_section: {},
        SectionParent_FK: null
      },
      schema: {
        groups: [
          {
            styleClasses: 'w-full',
            fields: [
              {
                type: 'vueMultiSelect',
                inputType: 'text',
                styleClasses: 'w-1/3',
                label: 'Facility',
                model: 'facility_section.Facility_FK',
                default: null,
                values: () => this.facilities,
                onChanged: async (model) => {
                  this.$emit('formLoading', true);

                  // Reset Section
                  delete model.SectionParent_FK;

                  this.sections = await this.getSectionOptions(model.facility_section.Facility_FK.id);

                  this.$emit('formLoading', false);
                },
                selectOptions,
                required: true,
                validator: ['required'],
              },
              {
                disabled: (model) => model.facility_section.Facility_FK === null
                    || typeof model.facility_section.Facility_FK === 'undefined'
                    || this.loadingSections
                ,
                type: 'vueMultiSelect',
                inputType: 'text',
                styleClasses: 'w-1/3',
                label: 'Section',
                model: 'SectionParent_FK',
                // If there is no Facility_FK set, show nothing
                // Otherwise find the sections that have that FK set.
                values: (model) => this.sections.filter(({Facility_FK}) =>
                    !model.facility_section.Facility_FK ? false : model.facility_section.Facility_FK.id === Facility_FK),
                selectOptions,
                required: true,
                validator: ['required'],
              },
            ]
          },
        ],
      },
      refs: [],
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
      },
      facilities: [],
      sections: [],
      options: [
        {
          endpoint: () => this.$api.facilities.list(),
          optionsFieldName: 'facilities',
          nameFieldName: 'FacilityReference',
          idFieldName: 'Facility_FK',
          modelArrayName: 'facility_section',
        },
      ],
    };
  },
  methods: {
    /**
     * Load sections manually using Facility keys
     * @returns {Promise<void>}
     */
    async postOptions() {
      // Get all ID's of facilities being passed in
      let newId = this.model.facility_section.Facility_FK;

      // Do we even need to do an API Call?
      if (newId &&
          !this.sections.find(({Facility_FK}) => newId.id === Facility_FK)
      ) {
        await this.loadSections(newId);
        await this.loadModelReferenceIntoObject('SectionParent_FK', 'sections');
      }
    },
    async loadSections(newId) {
      return new Promise(async (resolve) => {
          const sections = await Promise.all(await this.getSectionOptions(newId.id));
          this.sections = sections.flatMap((i) => i);
          resolve();
      });
    },
    async getSectionOptions(Facility_FK) {
      this.loadingSections = true;

      const { data } = await this.$api.facilities.sections.list(Facility_FK);

      this.loadingSections = false;
      return data.data.map((i) => ({ id: i.id, name: i.Section, Facility_FK }));
    },
  },
};
</script>
